<div class="main-div">
  <div class="content-wrapper">
    <div class="textArea">  
      <img src="assets/images/new/Unity_Logo_250x350.svg" alt="image" class="errorLogo" />
      <app-h1 class="mt-4">403</app-h1>
      <app-h2>Unauthorised</app-h2>
      <app-h3><b>Sorry!</b></app-h3>
      <div>
        <app-p class="mb-3">You are not authorised to access the current page.</app-p>
        <app-p>Please contact your administrator to request access.</app-p>
        <app-p *ngIf="isDevelopment" class="dev-note mt-3">
          Note: If you are in development mode, this error may occur because the requested module has not been mapped in the application configuration.
        </app-p>
      </div>
      <div class="mt-5">
        <app-button theme="secondary-action" (clickEvent)="goBack()">
          Go Back
        </app-button>
      </div>
    </div>
  </div>
</div>
